// ai-search.js
(() => {
  const EDGE_SEARCH = "https://vljrbngfoeijiyctpekm.supabase.co/functions/v1/search_query";
  const EDGE_SUMMARY = "https://vljrbngfoeijiyctpekm.supabase.co/functions/v1/custom-summary";
  const AUTH_TOKEN =
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZsanJibmdmb2Vpaml5Y3RwZWttIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA3ODU5OTUsImV4cCI6MjA3NjM2MTk5NX0.UkTGxhofjRi3Tvl8fkqDneglZN6Bt66aBRTync7fJLA";

  const SHOP_DOMAIN = (window.Shopify && window.Shopify.shop) || window.location.hostname;

  /**
   * 🔍 Perform AI-powered product search and redirect
   * @param {string} query - The user's search input
   * @param {function} [onStatusChange] - Optional callback(statusText) for UI updates
   */
  async function searchProducts(query, onStatusChange) {
    const updateStatus = (msg) => {
      if (onStatusChange) onStatusChange(msg);
      else console.log("🧠 AI Search:", msg);
    };

    if (!query || typeof query !== "string" || !query.trim()) {
      updateStatus("⚠️ Please enter a search term.");
      return;
    }

    updateStatus("🔍 Searching...");

    try {
      // 1️⃣ Fetch product search results
      const res = await fetch(EDGE_SEARCH, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: AUTH_TOKEN,
        },
        body: JSON.stringify({ store_domain: SHOP_DOMAIN, query, limit: 3 }),
      });

      const data = await res.json();
      console.log("📡 Search response:", data);

      if (!res.ok || data.error) throw new Error(data.error?.message || "Search error");
      if (!data.results?.length) {
        updateStatus("😕 No results found.");
        return;
      }

      // 2️⃣ Prefetch AI summary
      const top = data.results[0];
      updateStatus(`🧠 Generating AI summary for: ${top.title}...`);
      let searchId = null;

      try {
        const summaryRes = await fetch(EDGE_SUMMARY, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: AUTH_TOKEN,
          },
          body: JSON.stringify({
            url: `${top.url}?query=${encodeURIComponent(query)}`,
          }),
        });

        const summaryData = await summaryRes.json();
        const summary = summaryData.summary || null;
        searchId = summaryData.search_id || null;

        if (summary) {
          const handleMatch = top.url.match(/\/products\/([^/?]+)/);
          const handle = handleMatch ? handleMatch[1] : null;
          if (handle) {
            localStorage.setItem(
              `ai_summary_cache_${handle}`,
              JSON.stringify({ query, summary, ts: Date.now() })
            );
            console.log("%c💾 Cached AI summary for " + handle, "color:#28a745; font-weight:bold;");
          }
        }
      } catch (summaryErr) {
        console.warn("⚠️ AI summary prefetch failed:", summaryErr);
      }

      // 3️⃣ Redirect to product page
      const connector = top.url.includes("?") ? "&" : "?";
      const redirectUrl = `${top.url}${connector}query=${encodeURIComponent(query)}${
        searchId ? `&search_id=${encodeURIComponent(searchId)}` : ""
      }`;

      updateStatus(`✅ Redirecting to: ${top.title}`);
      window.location.href = redirectUrl;
    } catch (err) {
      console.error("❌ AI search error:", err);
      updateStatus("❌ Error: " + err.message);
    }
  }

  // 🌐 Expose globally for other scripts
  window.searchProducts = searchProducts;
})();
